module.exports = __webpack_public_path__ + "static/media/place.33d7f735.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/components/Main/place.svg
// module id = 116
// module chunks = 0